import styled from '@emotion/styled'
import { useCallback } from 'react'
import { useHistory } from 'react-router'
import Card from '../../../../components/common/Card'
import Text from '../../../../components/common/Text'
import { PRIMARY, WHITE } from '../../../../constant/colors'
import { enrollmentWellBeingEdit } from '../../../../constant/path'
import {
  EClaimEnllomentItem,
  EClaimEnllomentItemList,
} from '../../../../services/e-claim/e-claim-types'
import { useRouter } from '../../../../utils/helper'
import { mobile } from '../../../../utils/responsive-helper'

const Layout = styled.div`
  > * {
    margin-top: 24px;
  }
  text-align: center;
`

const Row = styled.div`
  display: flex;
  flex-flow: row;
`

const LayoutCard = styled(Card)`
  background-color: WHITE;
  border-radius: 8px;
  margin-bottom: 24px;
  margin-top: 0px;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 56px;
  padding-right: 56px;

  ${mobile} {
    padding-left: 24px;
    padding-right: 24px;
  }
  /* border: solid 1px #dee2e6; */
`

const CardTotal = styled(Card)`
  background-color: ${PRIMARY};
  border-radius: 16px;
  padding-left: 16px;
  padding-right: 16px;
  margin-right: 8px;
  align-self: center;
`

export type WellBeingListProps = {
  eClaimEnrollment?: EClaimEnllomentItemList
}

const WellBeingList = (props: WellBeingListProps) => {
  const { eClaimEnrollment } = props
  const { query } = useRouter()

  const history = useHistory()
  const onClickCard = useCallback(
    (item: EClaimEnllomentItem) => {
      history.push({
        pathname: enrollmentWellBeingEdit({
          routeParam: {
            benefitYearId: query.benefitYearId,
            claimTypeId: item.claimTypeId.toString(),
          },
        }),
      })
    },
    [history, query.benefitYearId],
  )

  function compare(a: any, b: any) {
    if (a.claimTypeName < b.claimTypeName) {
      return -1;
    }
    if (a.claimTypeName > b.claimTypeName) {
      return 1;
    }
    return 0;
  }


  return (
    <Layout>
      {eClaimEnrollment?.sort(compare).map((eClaimEnrollmentItem, index) => {
        return (
          <LayoutCard
            key={`${index}-${eClaimEnrollmentItem.claimTypeId}`}
            onClick={() => onClickCard(eClaimEnrollmentItem)}
          >
            {' '}
            <Row style={{ justifyContent: 'space-between' }}>
              <Text type={'Bold'} size={22} style={{ textAlign: 'justify' }}>
                {eClaimEnrollmentItem.claimTypeName}
              </Text>
              <Row>
                <CardTotal className={'cardTotal'}>
                  <Text color={WHITE}>{eClaimEnrollmentItem.totalSelectedCoin} </Text>
                </CardTotal>
                <Text type={'Bold'} size={22} style={{ alignSelf: 'center' }}>
                  {'>'}
                </Text>
              </Row>
            </Row>
          </LayoutCard>
        )
      })}
    </Layout>
  )
}

export default WellBeingList
